import { Component, EventEmitter, Inject, OnInit, Input, Output } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { FeedbackLoginDialogService } from "./dialog-resposta-contestacao.service";
import { BeanContestationAnswer } from 'src/bean/BeanContestationAnswer';
import { MonitoriaService } from '../monitoria.service';
import { MonitoriaComponent } from "../monitoria.component";
import { ContestacaoMonitoriaDialog } from "../monitoria.component";
import {Observable, ReplaySubject, Subscription } from 'rxjs';
import { UsuarioService } from "src/app/usuario.service";
import { CadastroUsuarioService } from "../../cadastro-usuario/cadastro-usuario.service";
import { BeanUsuario } from "src/bean/BeanUsuario";
import { AESEncryptDecryptService } from "../../../AESEncryptDecryptService";
import { BeanContestation } from "src/bean/BeanContestation";
import { BeanMonitoryQuestionAnswer } from "src/bean/BeanMonitoryQuestionAnswer";


@Component({
    selector: 'dialog-resposta-contestacao',
    templateUrl: 'dialog-resposta-contestacao.html',
    styleUrls: ['../monitoria.component.css']
  })
  export class RespostaComentarioDialog implements OnInit {

    @Input()
    requiredFileType:string;

    fileName = '';
    uploadProgress:number;
    uploadSub: Subscription;

    contIdCdContestacao: number;
    ultimaRespostaContestacao: string;
    moniDhFeedbackAvaliado : string;

    //public anexoSpinner: Boolean = false;
    public contemRespostaAnexo: Boolean = false;
    public file:File = null;

    idUsuarioLogado : number =  Number( this._AESEncryptDecryptService.decrypt(localStorage.getItem("idUser")).trim());
    tipoUsuarioLogado : number = Number(this._AESEncryptDecryptService.decrypt(localStorage.getItem("idTipoUsuario")).trim());

    public beanRespostaContestation : BeanContestationAnswer = new BeanContestationAnswer(null,null,null,null,null,null,null,null,null);
    public lstBeanRespostaContestation : BeanContestationAnswer[]=[]

    public isAddContestacao : boolean = false;
    public base64Output : string;

    public permParaComentar = false;
    public sessionExpired: boolean = false;

    ngAfterContentChecked(){

      this.resetSessionExpired();
    }

    public setSessionExpired(errorResponse:any) {

      if(errorResponse.status == 401){

        this.sessionExpired = true;
      }

      return this.sessionExpired;
    }

    public resetSessionExpired(){

      if(this.sessionExpired){

        this.sessionExpired = false;

        setTimeout(() => this.dialogRef.close({sessionExpired:true}));
      }
    }


    public formResponderContestacao: FormGroup = new FormGroup({
      'recoTxRespostaContestacao': new FormControl(""),
      'recoInProcedente': new FormControl("", Validators.required),
      'usuaIdCdUsuario': new FormControl(this._AESEncryptDecryptService.decrypt(localStorage.getItem("idUser")).trim()),
      'usuaNmUsuario': new FormControl(this._AESEncryptDecryptService.decrypt(localStorage.getItem("nmUser")).trim()),
    })

    constructor(
      private monitoriaService: MonitoriaService,
      private userService: CadastroUsuarioService,
      public dialogRef: MatDialogRef<MonitoriaComponent>,
      private toastr: ToastrService,
      private router: Router,
      private _AESEncryptDecryptService: AESEncryptDecryptService,
      @Inject(MAT_DIALOG_DATA) public data: {
        mqa: BeanMonitoryQuestionAnswer
      },
    ) { }


    ngOnInit(): void {
      /*
      console.log("----------------------------------");     
      console.log(this.data.mqa.question.pergDsPergunta); ///pertgunta
      for(var bean of this.data.mqa.question.questionAnswers){ ///respostas
        console.log(bean.answer);
      }
      console.log("----------------------------------");
      */
    }

    salvarRespostaDaContestacao(){

      if(this.tipoUsuarioLogado == 4 && (this.formResponderContestacao.value.recoInProcedente == "" || this.formResponderContestacao.value.recoInProcedente == "")){
        this.toastr.error('Necessário selecionar se a contestação é Procedente ou Improcedente','RESPOSTA CONTESTACAO');
        return
      }


      if(this.formResponderContestacao.value.recoTxRespostaContestacao == ""){
        this.toastr.error('Necessário incluir o texto da resposta da contestação','RESPOSTA CONTESTACAO');
        return
      }

      this.beanRespostaContestation.contIdCdContestacao = this.contIdCdContestacao;
      this.beanRespostaContestation.recoTxRespostaContestacao = this.formResponderContestacao.value.recoTxRespostaContestacao;
      this.beanRespostaContestation.usuaIdCdUsuario = this.formResponderContestacao.value.usuaIdCdUsuario;
      this.beanRespostaContestation.recoInProcedente = this.formResponderContestacao.value.recoInProcedente;



      //SALVA A RESPOSTA DA CONTESTAÇÃO NO BANCO
      this.monitoriaService.addRespostaContestacaoMonitoria(this.beanRespostaContestation).then((retorno:BeanContestationAnswer)=>{

          this.formResponderContestacao.controls.recoTxRespostaContestacao.setValue("");


        if(this.formResponderContestacao.value.recoInProcedente != ""){

          let contestacao : BeanContestation = new BeanContestation(this.beanRespostaContestation.contIdCdContestacao,null,null,null,null,null,null,null,null,this.formResponderContestacao.value.recoInProcedente) 

          //atualizar contestação com status (procedente ou improcedente)
          this.monitoriaService.atualizarContestacaoMonitoria(contestacao).then((retorno2:BeanContestation)=>{
            this.toastr.info((this.formResponderContestacao.value.recoInProcedente == 'S' ? 'Procedente' : 'Improcedente'),'CONTESTAÇÃO ATUALIZADA' ); 
            
          }, errorResponse => {

            this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao retornar dados do usuario.','RESPOSTA DA CONTESTAÇÃO');
          }).catch((retorno:any) => {
            if(retorno.error.error_description.indexOf("Access token expired")>-1){
                alert("Sessão Expirada");
                this.router.navigate(['']);
              }
          });

        }


          //atualizar bean de usuario criou a respostaa da contestação
          this.userService.getUsuarioPorId(retorno.usuaIdCdUsuario).then((retorno2:BeanUsuario)=>{
            retorno.userRespostaContestacao = retorno2
          }, errorResponse => {

            this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao retornar dados do usuario.','RESPOSTA DA CONTESTAÇÃO');
          }).catch((retorno:any) => {
            if(retorno.error.error_description.indexOf("Access token expired")>-1){
                alert("Sessão Expirada");
                this.router.navigate(['']);
              }
          });







          this.dialogRef.close(retorno);
          this.toastr.success('Salvo com sucesso.','RESPOSTA CONTESTAÇÃO');

      }, errorResponse => {
        this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao gravar resposta contestação.','RESPOSTA CONTESTAÇÃO');

      }).catch((retorno:any) => {

        if(retorno.error.error_description.indexOf("Access token expired")>-1){
            alert("Sessão Expirada");
            this.router.navigate(['']);
          }
      });

    }

    closeDialog() {
      this.dialogRef.close();
    }


    //seta o arquivo no bean de create contastation
  onFileSelectedRespostaContestacao(event, fileUpload) {

    //this.anexoSpinner = true;
    this.file = event.target.files[0];

    if (this.file) {

        this.fileName = this.file.name;

        this.convertFile(this.file).subscribe(base64 => {

          //preencher o arquivo no Bean de contestacao
          this.beanRespostaContestation.recoDsArquivo = base64
          this.beanRespostaContestation.recoDsNomeArquivo = this.file.name

          this.base64Output = base64;


        });

    }
  }



  convertFile(file : File) : Observable<string> {
    const result = new ReplaySubject<string>(1);
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = (event) => result.next(btoa(event.target.result.toString()));
    return result;
  }


  cancelUpload() {
    this.uploadSub.unsubscribe();
    this.reset();
  }

  reset() {
    this.uploadProgress = null;
    this.uploadSub = null;
  }


  downloadAnexoRespostaContestacao(){
    //this.anexoSpinner = true
    this.monitoriaService.downloadAnexoContestacao(this.beanRespostaContestation.contIdCdContestacao)
    .then((ret)=>{

      const downloadLink = document.createElement('a');

      downloadLink.href = 'data:application/octet-stream;base64,' + ret.contDsArquivo;
      downloadLink.download = ret.contDsNomeArquivo;
      downloadLink.click();
      //this.anexoSpinner = false

    }, errorResponse => {

      this.setSessionExpired(errorResponse);
    })

  }

  deletarRespostaAnexo(){

      this.toastr.success('Arquivo excluido com sucesso!')
      //this.anexoSpinner = false
      this.contemRespostaAnexo = false
      this.fileName = ''
      this.file = null
      this.beanRespostaContestation.recoDsArquivo = null
      this.beanRespostaContestation.recoDsNomeArquivo = null

  }


  }
